import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../../features/auth/auth-context';
import { defaultAdminHome } from '../../features/auth/default-admin-home';
import { DashboardContent } from '../../features/dashboard/components/dashboard-page';
import { PageHeader } from '../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/')({
  staticData: { breadcrumb: 'Главная' },
  component: DashboardPage,
});

function DashboardPage() {
  const roles = useAuth().adminRoles;
  const home = defaultAdminHome(roles);
  if (home !== '/') return <Navigate to={home} />;
  return (
    <div>
      <PageHeader
        title="Дашборд"
        description="Операционная сводка по очереди модерации, источникам, LLM, контенту и аудитории."
      />
      <div className="mt-6">
        <DashboardContent />
      </div>
    </div>
  );
}
